import { t } from "i18next";
import { HttpService } from "../http";
import { DASHBOARD_CHATS, DASHBOARD_REPORTS, DASHBOARD_STATS } from "./endpoints";
export class DashboardStatServices extends HttpService {
  async getStatsData(payload: {
    onSuccess?: (data: any) => void;
    onError?: (err: any) => void;
    baseUrl: string;
  }): Promise<any> {
    const { onSuccess, onError, baseUrl } = payload;
    const fullUrl = `${baseUrl}/${DASHBOARD_STATS}`;

    try {
      const apiResponse = await this.get(fullUrl);

      const result = apiResponse?.data?.data?.data;
      if (onSuccess) {
        onSuccess(result);
      }
      return result;
    } catch (error: any) {
      // Safely extract error message
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      if (onError) {
        onError(message);
      }

      throw error;
    }
  }

  async getReports(payload: {
    onSuccess?: (response: any, count: number) => void;
    onError?: (err: any) => void;
    data: any;
    baseUrl: string;
  }): Promise<any> {
    const { onSuccess, onError, data, baseUrl } = payload;
    const fullUrl = `${baseUrl}/${DASHBOARD_REPORTS}`;
    try {
      const apiResponse = await this.get(fullUrl, { ...data });
      console.log(apiResponse);

      const result = apiResponse?.data?.data?.files?.data;
      const count = apiResponse?.data?.data?.files?.pagination?.totalItems;
      console.log(result);
      if (onSuccess) {
        onSuccess(result, count);
      }
      return result;
    } catch (error: any) {
      // Safely extract error message
      const message =
        error?.response?.data?.message ||
        error?.message ||
        t("common:dashboard.somethingWentWrong");

      if (onError) {
        onError(message);
      }

      throw error;
    }
  }

  async getChats(payload: {
    onSuccess?: (response: any, count: number) => void;
    onError?: (err: any) => void;
    data: any;
    baseUrl: string;
  }): Promise<any> {
    const { onSuccess, onError, data, baseUrl } = payload;
    const fullUrl = `${baseUrl}/${DASHBOARD_REPORTS}`;
    try {
      const apiResponse = await this.get(fullUrl, { ...data });
      console.log(apiResponse);

      const result = apiResponse?.data?.data?.userChat?.data;
      const count = apiResponse?.data?.data?.userChat?.pagination?.totalItems;
      
      if (onSuccess) {
        onSuccess(result, count);
      }
      return result;
    } catch (error: any) {
      // Safely extract error message
      const message =
        error?.response?.data?.message ||
        error?.message ||
        t("common:dashboard.somethingWentWrong");

      if (onError) {
        onError(message);
      }

      throw error;
    }
  }

    async getLastChatsByType(payload: {
    onSuccess?: (response: any) => void;
    onError?: (err: any) => void;
    data?: any;
    baseUrl: string;
  }): Promise<any> {
    const { onSuccess, onError, data, baseUrl } = payload;
    const fullUrl = `${baseUrl}/${DASHBOARD_CHATS}`;

    try {
      const apiResponse = await this.get(fullUrl, { ...data });
      console.log("Last chats by type API Response:", apiResponse);

      console.log(apiResponse?.data?.data)
      const result = apiResponse?.data?.data || apiResponse?.data;


      if (onSuccess) {
        onSuccess(result);
      }

      return result;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        t("common:dashboard.somethingWentWrong");
      if (onError) {
        onError(message);
      }

      throw error;
    }
  }

}
